import React from "react";
import EventContentView from "./EventContentView";
import { EventContentProps, UseEventContentProps } from "./type";
import { useEventContent } from "./useEventContent";

function EventContent(props: EventContentProps) {
  const hook: UseEventContentProps = useEventContent(props);

  return <EventContentView props={props} hook={hook} />;
}
export default React.memo(EventContent);
